import React, { useState } from 'react';
import { connect } from 'react-redux';
import { MoreHorizontal, Edit2, Image, Archive } from 'react-feather';
import { Button, ActionList, Popover } from 'components/ui';
import LessonTemplateUpdateModal from 'components/content/TemplateUpdateModal';
import LessonTemplateImagesModal from 'components/content/TemplateImagesModal';
import { routes } from 'constants/config';

const TemplateSettingsButton = ({ templateId, templateActive }) => {
  const [settingsPopoverVisible, setSettingsPopoverVisible] = useState(false);
  const [updateModalVisible, setUpdateModalVisible] = useState(false);
  const [imagesModalVisible, setImagesModalVisible] = useState(false);

  const actionListActivator = (
    <Button
      aria-label={t('templates.settings_button.trigger_label')}
      aria-expanded={settingsPopoverVisible}
      className="TemplateSettingsPopover--Trigger"
      data-testid="TemplateSettingsPopoverTrigger"
      onClick={() => setSettingsPopoverVisible(true)}
      disabled={templateActive}
    >
      <MoreHorizontal />
    </Button>
  );

  const closeUpdateModal = () => {
    setUpdateModalVisible(false);
  };

  const closeImagesModal = () => {
    setImagesModalVisible(false);
  };

  return (
    <>
      <div>
        <Popover
          className="TemplateSettingsPopover"
          activator={actionListActivator}
          visible={settingsPopoverVisible}
          align="right"
          onClose={() => setSettingsPopoverVisible(false)}
        >
          <div className="TemplateSettingsPopover--List">
            <ActionList
              items={[
                {
                  content: t('templates.settings_button.details'),
                  FeatherIcon: Edit2,
                  onClick: () => {
                    setUpdateModalVisible(true);
                    setSettingsPopoverVisible(false);
                  },
                },
                {
                  content: t('templates.settings_button.images'),
                  FeatherIcon: Image,
                  onClick: () => {
                    setImagesModalVisible(true);
                    setSettingsPopoverVisible(false);
                  },
                },
                {
                  content: t('common.archive'),
                  FeatherIcon: Archive,
                  url: routes.ARCHIVE_TEMPLATE(templateId),
                  dataMethod: 'put',
                  dataConfirm: t('templates.confirm_archive'),
                },
              ]}
            />
          </div>
        </Popover>
      </div>
      {updateModalVisible && (
        <LessonTemplateUpdateModal closeModal={closeUpdateModal} />
      )}
      {imagesModalVisible && (
        <LessonTemplateImagesModal
          contentId={templateId}
          closeModal={closeImagesModal}
        />
      )}
    </>
  );
};

const mapStateToProps = ({ editor }) => ({
  templateId: editor.templateId,
  templateActive: editor.templateActive,
});

export default connect(mapStateToProps)(TemplateSettingsButton);
